var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('search-box',{staticClass:"w-100",attrs:{"results":_vm.searchedCities,"placeholder":this.name || 'Search city...'},on:{"typing":_vm.searchCity,"selected":_vm.selectCity}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }